import { type Route } from '#app/routes/mocra+/_sections+/+types/609.ts'
import { SECTIONS } from '#app/routes/mocra+/_sections+/section-data.ts'
import { SectionDetail } from '#app/routes/mocra+/_sections+/section-detail.tsx'

export const meta: Route.MetaFunction = () => [
	{ title: 'MoCRA — §609 Labeling & Responsible Person Details' },
]

export default function Section609() {
	return <SectionDetail section={SECTIONS['609']} />
}
